import React, { useRef, useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";
import "../pages/styles/about.css";
import Media from "react-media";
import { Link } from "react-router-dom";
import "../components/styles/buttons.css";
import { TweenMax, Power3 } from "gsap";
import doctor1 from "./media/doctor1.svg";
import doctor2 from "./media/doctor2.svg";
import doctor3 from "./media/doctor3.png";
import doctor4 from "./media/doctor4.png";
import doctor5 from "./media/doctor5.png";
import doctor6 from "./media/doctor6.png";
import Slider from "infinite-react-carousel";
import {useTranslation, Trans} from 'react-i18next'

const About = () => {
  
  const { t } = useTranslation();

  const settings = {
    adaptiveHeight: true,
    centerMode: true,
    arrows: true,
    shift: 100,
    duration: 300,
    slidesPerRow: 3
  };

  const doctorContein1 = {
    name: "Dra. Ericka Madrigal Romero",
    info: t('aboutDoctor1')
  };
  const doctorContein2 = {
    name: "Dr. Oscar Soto Chacon",
    info: t('aboutDoctor2')
  };
  const doctorContein3 = {
    name: "Dr. Victor Sanchez Venegas",
    info: t('aboutDoctor3')
  };
  const doctorContein4 = {
    name: "Dr. Andres Fernandez Rodriguez",
    info: t('aboutDoctor4')
  };
  const doctorContein5 = {
    name: "Dr. Alejandro Mora Lasso",
    info: t('aboutDoctor5')
  };
  const doctorContein6 = {
    name: "Dra. Tatiana Madrigal Gutierrez ",
    info: t('aboutDoctor6')
  };
  const [useInfo, setInfo] = useState({
    name: doctorContein1.name,
    info: doctorContein1.info,
    image: doctor2
  });
  const changeInfo = {
    doctor1: () => {
      setInfo({
        name: doctorContein2.name,
        info: doctorContein2.info,
        image: doctor1
      });
    },
    doctor2: () => {
      setInfo({
        name: doctorContein1.name,
        info: doctorContein1.info,
        image: doctor2
      });
    },
    doctor3: () => {
      setInfo({
        name: doctorContein3.name,
        info: doctorContein3.info,
        image: doctor3
      });
    },
    doctor4: () => {
      setInfo({
        name: doctorContein4.name,
        info: doctorContein5.info,
        image: doctor4
      });
    },
    doctor5: () => {
      setInfo({
        name: doctorContein5.name,
        info: doctorContein5.info,
        image: doctor5
      });
    },
    doctor6: () => {
      setInfo({
        name: doctorContein6.name,
        info: doctorContein6.info,
        image: doctor6
      });
    }
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>{t('titleAbout')}</title>
        <meta name="description" content="Sobre la Cliníca Sol Oeste" />
        <meta name="keywords" content="clinica,dental,santa ana,muelas, dientes, san jose, costa rica, dental care, teeth."/>
      </Helmet>
      <Navbar></Navbar>
      <header className="header-home about">
        <div className="header-info about">
          <h1>{t('homeSection2Title')}</h1>
          <hr />
          <p className="heroText">
            <Trans>{t('aboutParaf')}</Trans>
          </p>
          <br />
        </div>
        <div className="header-img"></div>
      </header>
      <section className="section-about conteiner">
        <div className="info-about">
          <h2>{t('aboutTitle')}</h2>
          <hr />
          <p>
            <Trans>{t('aboutParaf2')}</Trans>
          </p>
        </div>
        <div className="wrapper-doctors">
          <div className="doctor-img">
            <img id="img" src={useInfo.image} alt="" />
            <img src="" alt="" />
          </div>
          <div className="doctor-info">
            <h2 id="name">{useInfo.name}</h2>
            <hr />
            <Trans><p id="info">{useInfo.info}</p></Trans>
          </div>
        </div>
      </section>
      <section className="wrapper-carrusel conteiner ">
        <Slider {...settings}>
          <div
            onClick={changeInfo.doctor1}
            className="box-carrusel doctor-about-1"
          >
            <br />
            <p>Dr. Oscar Soto</p>
          </div>
          <div
            onClick={changeInfo.doctor2}
            className="box-carrusel doctor-about-2"
          >
            <br />
            <p>Dra. Ericka Madrigal Soto</p>
          </div>
          <div
            onClick={changeInfo.doctor3}
            className="box-carrusel doctor-about-3"
          >
            <br />
            <p>Dr. Victor Sanchez </p>
          </div>
          <div
            onClick={changeInfo.doctor4}
            className="box-carrusel doctor-about-4"
          >
            <br />
            <p>Dr. Andres Fernandez</p>
          </div>
          <div
            onClick={changeInfo.doctor5}
            className="box-carrusel doctor-about-5"
          >
            <br />
            <p>Dr. Alejandro Mora </p>
          </div>
          <div
            onClick={changeInfo.doctor6}
            className="box-carrusel doctor-about-6"
          >
            <br />
            <p>Dra. Tatiana Madrigal </p>
          </div>
        </Slider>
      </section>
      <Footer></Footer>
    </React.Fragment>
  );
};

export default About;
